import { ChainAvatar } from '@Components/ConnectedChainCard';
import { FieldService } from '@Models';
import { FIELD_SERVICE_AVATAR_TEXT_COLOR, getFieldServiceInitials } from '../assignFieldServiceColor';

interface IdentitySectionProps {
  fieldService: FieldService;
  color: string;
}

const IdentitySection = ({ fieldService, color }: IdentitySectionProps) => {
  return (
    <div className="flex min-w-0 items-center gap-2.5">
      <ChainAvatar
        size="sm"
        className="h-8 w-8"
        initials={getFieldServiceInitials(fieldService.name)}
        color={color}
        textColor={FIELD_SERVICE_AVATAR_TEXT_COLOR}
      />
      <span className="truncate text-xl font-bold text-gray-900">{fieldService.name}</span>
    </div>
  );
};

export default IdentitySection;
